import { publicApi, protectedApi } from '../config/api.config';

class BaseApi {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }

  // Determine which Axios instance to use
  getApiInstance(useProtected = true) {
    return useProtected ? protectedApi : publicApi;
  }

  // Create a new entity
  async create(data, useProtected = true) {
    const api = this.getApiInstance(useProtected);
    const response = await api.post(`/${this.endpoint}`, data);
    return response.data;
  }

  // Update an entity by ID
  async update(id, data, useProtected = true) {
    const api = this.getApiInstance(useProtected);
    const response = await api.put(`/${this.endpoint}/${id}`, data);
    return response.data;
  }

  // Delete an entity by ID
  async delete(id, useProtected = true) {
    const api = this.getApiInstance(useProtected);
    const response = await api.delete(`/${this.endpoint}/${id}`);
    return response.data;
  }

  // Get an entity by ID
  async getById(id, useProtected = true) {
    const api = this.getApiInstance(useProtected);
    const response = await api.get(`/${this.endpoint}/${id}`);
    return response.data;
  }

  // Get all entities
  async getAll(useProtected = true) {
    const api = this.getApiInstance(useProtected);
    const response = await api.get(`/${this.endpoint}`);
    return response.data;
  }
}

export default BaseApi;
